import React, {FC, useState} from "react";
import {Button} from "antd";
import {EditOutlined} from "@ant-design/icons";
import i18n from "../../../services/i18n";
import {GetBookingByIdQuery, GetBookingByIdWithCourseLessonBookingsQuery} from "../../../generated/graphql";
import LessonBookingAdjustmentModal from "./LessonBookingAdjustmentModal";
import {canAdjustLessonBooking} from "./lessonBookingAdjustEligibility";
import css from "./AdjustLessonBookingButton.less";

type BookingData = GetBookingByIdQuery["bookingById"] | GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"];

type AdjustLessonBookingButtonProps = {
    booking?: BookingData;
    refetch: () => void;
};

const AdjustLessonBookingButton: FC<AdjustLessonBookingButtonProps> = ({booking, refetch}) => {
    const [open, setOpen] = useState(false);

    if (!canAdjustLessonBooking(booking)) {
        return null;
    }

    // Type-Cast analog zu MoreMenuSettlementDetails.tsx — SettlementDetails liefert
    // bereits ausschliesslich die WithCourseLessonBookings-Variante.
    const bookingForAdjustment = booking as GetBookingByIdWithCourseLessonBookingsQuery["bookingByIdWithCourseLessonBookings"];

    return (
        <div className={css.wrapper}>
            <Button block size="small" type="primary" icon={<EditOutlined />} className={css.orangeButton} onClick={() => setOpen(true)}>
                {i18n.containers.invoice.SettlementDetails.moreMenu.adjustLessonBooking()}
            </Button>
            {open && <LessonBookingAdjustmentModal open={open} onClose={() => setOpen(false)} booking={bookingForAdjustment} onSuccess={refetch} />}
        </div>
    );
};

export default AdjustLessonBookingButton;
